import styled from "styled-components";

export const DailySettlementExpenseMainContentWrapper = styled.div`
  margin: 20px 0 43px;
  display: flex;
  justify-content: space-between;
  gap: 40px;
`;

export const DailySettlementExpenseMainChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 130px;

  > .chart {
    width: 400px;
  }
`;

export const DailySettlementExpenseMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-end;
`;

export const DailySettlementExpenseMainTableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DailySettlementExpenseMainTableItem = styled.div`
  display: flex;

  > .type {
    text-align: left !important;
  }

  > .item {
    background: #fff;

    > input {
      width: 100%;
      border: none;
      outline: none;
      text-align: center;
      color: #121212;
      font-family: Pretendard;
      font-weight: 600;
      font-size: 15px;
    }
  }
`;

export const DailySettlementExpenseMainTableWrapper = styled.div<{
  width?: string;
}>`
  color: #121212;
  text-align: right;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 15px;

  .header {
    width: 120px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    text-align: center;
    margin-right: 4px;
  }

  .item {
    width: ${({ width }) => (width ? width : "100px")};
    height: 30px;
    border: 1px solid #ecf0f3;
    border-right: 1px solid #d9d9d9;
    line-height: 30px;
    color: #121212;
    padding: 0 10px;
    box-sizing: border-box;

    &.center {
      text-align: center;
    }
  }
`;

export const DailySettlementExpenseMainTableHeader = styled.div`
  display: flex;

  > .item {
    background: #ecf0f3;
    text-align: center;

    &.right {
      text-align: right;
    }
  }
`;
